module.exports = __webpack_public_path__ + "static/img/gsbzizhi1.4f3826c1.jpg";